"use strict";
/**
 * 桁数区切り数字文字列に変換する関数
 * @param productPrice
 * @returns
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.digitSeparator = void 0;
var digitSeparator = function (productPrice) {
    var digitSeparator = String(productPrice).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    return digitSeparator;
};
exports.digitSeparator = digitSeparator;
